export default __webpack_public_path__ + "static/splunk-be62a4a52a20bdfeef960256a3343128.jpg";